import userFuncs from "./users";
import hostFuncs from "./hosts/hostPlayerLists";
import gameFuncs from "./hosts/gameFunctions";
import sessionsFuncs from "./sessions";
import curPlayersFuncs from "./currentPlayers";
import requestFuncs from "./requests";
import toasts from "./toastNotifications";
import waitlistFuncs from "./waitlist";

export default {
  addUserAndDocsToDB: userFuncs.addUserAndDocsToDB,
  saveNote: userFuncs.saveNote,
  getNote: userFuncs.getNote,

  addPlayerToWhitelist: hostFuncs.addPlayerToWhitelist,
  addPlayerToBlacklist: hostFuncs.addPlayerToBlacklist,
  isWhitelisted: hostFuncs.isWhitelisted,
  isPlayerOnWhitelist: hostFuncs.isPlayerOnWhitelist,
  removeFromWhitelist: hostFuncs.removeFromWhitelist,
  removeFromBlacklist: hostFuncs.removeFromBlacklist,
  isBlacklisted: hostFuncs.isBlacklisted,
  isPlayerOnBlacklist: hostFuncs.isPlayerOnBlacklist,

  addPlayerToGame: curPlayersFuncs.addPlayerToGame,
  removePlayerFromGame: curPlayersFuncs.removePlayerFromGame,
  addPlayerToTableManually: curPlayersFuncs.addPlayerToTableManually,
  confirmAddPlayer: curPlayersFuncs.confirmAddPlayer,
  declineJoinGame: curPlayersFuncs.declineJoinGame,

  createGame: gameFuncs.createGame,
  editGame: gameFuncs.editGame,
  deleteGame: gameFuncs.deleteGame,
  startGame: gameFuncs.startGame,
  changeGameStatus: gameFuncs.changeGameStatus,
  endGame: gameFuncs.endGame,

  startGameSession: sessionsFuncs.startGameSession,
  endGameSession: sessionsFuncs.endGameSession,
  startPlayerSession: sessionsFuncs.startPlayerSession,
  endPlayerSession: sessionsFuncs.endPlayerSession,
  getPlayerSessions: sessionsFuncs.getPlayerSessions,
  getGameSessions: sessionsFuncs.getGameSessions,

  acceptRequest: requestFuncs.acceptRequest,
  deleteRequest: requestFuncs.deleteRequest,
  setRequest: requestFuncs.setRequest,
  sendJoinGameRequest: requestFuncs.sendJoinGameRequest,
  pendingConfirmReq: requestFuncs.pendingConfirmReq,
  hostConfirmReq: requestFuncs.hostConfirmReq,
  playerConfirmReq: requestFuncs.playerConfirmReq,

  setNotification: toasts.setNotification,
  sendJoinGameNotification: toasts.sendJoinGameNotification,
  sendAcceptNotification: toasts.sendAcceptNotification,
  sendDeclineNotification: toasts.sendDeclineNotification,
  sendConfirmationPendingNotification:
    toasts.sendConfirmationPendingNotification,
  sendPlayerDeclinedNotification: toasts.sendPlayerDeclinedNotification,
  sendHostConfirmedNotification: toasts.sendHostConfirmedNotification,
  sendPlayerConfirmedNotification: toasts.sendPlayerConfirmedNotification,
  sendPlayerAddedSuccessNotification: toasts.sendPlayerAddedSuccessNotification,

  removeFromWaitlist: waitlistFuncs.removeFromWaitlist,
  moveToWaitlist: waitlistFuncs.moveToWaitlist,
  addPlayerToWaitManually: waitlistFuncs.addPlayerToWaitManually,
};
